<template>
  <div class="cash-boxes-opening-balance">
    <draggable-dynamic-table ref="cashBoxesOpeningBalanceList"
                             :in-modal="true"
                             :fix-screen="true"
                             :active-grid="true"
                             :options="options"
                             :columns="columnsLabel"
                             @row:clicked="handleRowClicked($event)"
                             @filter:remove="setFilter($event)"
                             @filter:set="setFilter($event)"
                             @sort:set="setSort($event)"
                             @load:more="getCashBoxesOpeningBalance"
                             v-model="data"/>

    <!-- insert new cashbox prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="newSuggestCashBoxPromptStatus">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="$u.click('insertCashBoxBTN')">
              <custom-icon icon="save-icon" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.cashBoxes.insert.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="newSuggestCashBoxPromptStatus = false">
              <custom-icon icon="circle-x-icon" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content">
        <template>
          <keep-alive>
            <insert-cash-box class="p-2" :in-modal="true" @inserted="handleInsertNewCashBox($event)"/>
          </keep-alive>
        </template>
      </div>

    </vs-prompt>

    <!-- insert cash boxes opening balance prompt -->
    <vs-prompt
      class="big-prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="insertOpeningInventoryPromptStatus">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="$u.click('saveBTN')">
              <custom-icon icon="save-icon" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.cashBoxes.openingBalance.insert.title') }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="insertOpeningInventoryPromptStatus = false">
              <custom-icon icon="circle-x-icon" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content p-2">
        <insert-cash-boxes-opening-balance/>
      </div>

    </vs-prompt>

    <!-- edit cash boxes opening balance prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="editOpeningInventoryPromptStatus">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="$u.click('saveBTN')">
              <custom-icon icon="save-icon" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('treasury.cashBoxes.openingBalance.edit.title', {cashBox: selectedCashBox.name}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="editOpeningInventoryPromptStatus = false">
              <custom-icon icon="circle-x-icon" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content p-2">
        <edit-cash-boxes-opening-balance :cash-box="selectedCashBox"/>
      </div>

    </vs-prompt>

    <button id="InsertOpeningInventoryBTN"
            @click="newSuggestCashBoxPromptStatus = true"
            v-show="false"/>
  </div>
</template>

<script>
import axios from 'axios'
import DraggableDynamicTable from '@/components/draggableDynamicTable/draggableDynamicTable'
import {
  getCashBoxesOpeningInventories
} from '@/http/requests/openingInventories'
import SelectCashBoxes from '@/views/admin/treasury/cashBoxes/select/selectCashBoxes'
import InsertCashBox from '@/views/admin/treasury/cashBoxes/insert/insertCashBox'
import InsertCashBoxesOpeningBalance from './insertCashBoxesOpeningBalance'
import {
  deleteCashBoxesOpeningInventories,
  getCashBoxOpeningInventories
} from '../../../../../http/requests/openingInventories'
import EditCashBoxesOpeningBalance from './editCashBoxesOpeningBalance'
import CustomIcon from '../../../../../components/customIcon/customIcon'
import {getCashBoxes} from "../../../../../http/requests/cashBoxes";

export default {
  name: 'cashBoxesOpeningBalance',
  components: {
    CustomIcon,
    EditCashBoxesOpeningBalance,
    InsertCashBoxesOpeningBalance,
    InsertCashBox,
    SelectCashBoxes,
    DraggableDynamicTable},
  data () {
    return {
      newSuggestCashBoxPromptStatus: false,
      insertOpeningInventoryPromptStatus: false,
      editOpeningInventoryPromptStatus: false,
      page: 1,
      filters: {},
      sorts: [],
      endedList: false,
      loadingTimer: 0,
      options: {
        rowKeyField: 'id'
      },
      columnsLabel: [
        /*{
          field: 'delete',
          headerName: 'حذف',
          width: '70px',
          minWidth: 70,
          actions: true,
          showAction: 'always',
          action: {
            color: 'danger',
            icon: 'trash-icon',
            iconPack: 'useral',
            type: 'button'
          },
          event: 'row:deleted'
        },*/
        {
          field: 'price',
          i18n: 'treasury.cashBoxes.openingBalance.table.header.price',
          hideCurrency: true,
          width: '200px',
          minWidth: 200,
          align: 'right',
          footer: {
            // type: 'auto-sum',
            // textType: 'price'
          }
        },
        {
          field: 'name',
          i18n: 'treasury.cashBoxes.openingBalance.table.header.name',
          align: 'left',
          ellipsis: true,
          width: '200px',
          minWidth: 200,
          sortable: true,
          filter: false,
          filterTypes: [
            {
              icon: 'magnifying-glass-icon',
              name: 'شامل شود',
              i18n: 'draggableTable.filter.types.search',
              id: 1
            }
          ]
        },
        {
          field: 'rowNumber',
          i18n: 'treasury.cashBoxes.openingBalance.table.header.row',
          align: 'center',
          width: '70px',
          minWidth: 70,
          fixed: true,
          footer: {}
        }
      ],
      openingBalanceData: [],
      data: [],
      selectedCashBox: {}
    }
  },
  created () {
    this.getCashBoxesOpeningBalance()
    this.checkOpeningBalanceStatus()
  },
  methods: {
    getCashBoxesOpeningBalance () {
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(() => {
        if (!this.endedList) {
          // if (this.$refs.cashBoxesOpeningBalanceList && this.data.length === 0) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'FirstLoad'
          // else if (this.$refs.cashBoxesOpeningBalanceList && this.data.length > 0) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'Loading'

          getCashBoxesOpeningInventories(this.page).then(response => {
            const cashBoxes = response.data.data

            this.total_count = response.data.pagination.total

            cashBoxes.forEach((cashBox) => {
              this.openingBalanceData.push({
                rowNumber: this.total_count - this.openingBalanceData.length,
                id: cashBox.id,
                name: cashBox.name,
                price: this.$u.priceFormat(cashBox.price),
                flag: 'SAVED'
              })
            })

            const price_index = this.columnsLabel.map((e) => {
              return e.field
            }).indexOf('price')
            if (price_index > -1) {
              this.columnsLabel[price_index].footer.value = this.$u.priceFormat(response.data.extra.total_price, true)
            }
            this.getCashBoxes()
          }).catch((error) => {
            if (axios.isCancel(error)) {
              /*this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
                text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })*/
            } else {
              // if (this.$refs.cashBoxesOpeningBalanceList) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'Danger'
            }
          })
        }
      }, 300)
    },
    getCashBoxes () {
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(() => {
        if (!this.endedList) {
          if (this.$refs.cashBoxesOpeningBalanceList && this.data.length === 0) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'FirstLoad'
          else if (this.$refs.cashBoxesOpeningBalanceList && this.data.length > 0) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'Loading'

          getCashBoxes(this.page, this.filters, this.sorts).then(response => {
            this.endedList = response.data.data.length === 0
            const cashBoxes = response.data.data
            cashBoxes.forEach((cash) => {
              let price = 0
              const cashIndex = this.openingBalanceData.map(elm => elm.id).indexOf(cash.id)
              if (cashIndex > -1) {
                price = this.openingBalanceData[cashIndex].price || 0
              }
              this.data.push({
                rowNumber: this.data.length + 1,
                id: cash.id,
                name: cash.name,
                price: price,
                flag: cashIndex === -1 ? 'new' : 'edit'
              })
            })
            this.page = response.data.pagination.current_page + 1
            if (response.data.pagination.current_page === 1) {
              const row_index = this.columnsLabel.map((e) => {
                return e.field
              }).indexOf('rowNumber')
              this.columnsLabel[row_index].footer.value = response.data.pagination.total
            }

            if (this.$refs.cashBoxesOpeningBalanceList) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = ''
          }).catch((error) => {

            if (this.$refs.cashBoxesOpeningBalanceList && !axios.isCancel(error)) this.$refs.cashBoxesOpeningBalanceList.loadMoreStatus = 'Danger'
          })
        }
      }, 300)
    },
    setFilter (filters, remove) {
      this.selectedFilters = filters
      const filters_list = {}
      Object.keys(filters).forEach((key) => {
        switch (key) {

          case 'name':
          if (filters[key].search !== '') filters_list.name = `${  filters[key].search}`
            break

          case 'balance':
          if (filters[key].search !== '') filters_list.balance = `${  filters[key].search  },${  filters[key].type.id}`
            break
        }
      })

      this.data = []
      this.page = 1
      this.endedList = false
      this.filters = filters_list
      this.$nextTick(() => {
        this.getCashBoxes()
      })
    },
    setSort (sorts) {
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

          case 'rowNumber':
            sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
            break

          case 'name':
            sorts_list.push(`order[0]=name,${  sorts[key] ? 'desc' : 'asc'}`)
            break

          case 'balance':
            sorts_list.push(`order[0]=virtual_balance,${  sorts[key] ? 'desc' : 'asc'}`)
            break
        }
      })

      this.data = []
      this.page = 1
      this.endedList = false
      this.sorts = sorts_list
      this.$nextTick(() => {
        this.getCashBoxes()
      })
    },
    handleDeleteRow (row) {
      if (row) {
        const index = this.data.map((elm) => {
          return elm.id
        }).indexOf(row.id)
        if (index > -1 && row.id !== 0) {
          deleteCashBoxesOpeningInventories(row.id).then(() => {
            this.$vs.notify({
              title: this.$t('alert.message.title'),
              text: this.$t('treasury.cashBoxes.openingBalance.notifications.delete.success'),
              color: 'success',
              time: 2400,
              icon: 'icon-check',
              iconPack: 'feather'
            })

            this.data.splice(index, 1)
            this.$store.dispatch('helper/changeOpeningBalance')
          }).catch((error) => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
                text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            } else {
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('treasury.cashBoxes.openingBalance.notifications.delete.error'),
                color: 'danger',
                time: 2400,
                icon: 'icon-alert-circle',
                iconPack: 'feather'
              })
            }
          })
        }
      }
    },
    handleRowClicked (row) {
      if (!this.$store.state.helper.openingBalanceLocked) {
        this.selectedCashBox = row
        this.editOpeningInventoryPromptStatus = true
      }
    },
    checkOpeningBalanceStatus () {
      if (this.$store.state.helper.openingBalanceLocked) {
        const mapper = this.columnsLabel.map(elm => { return elm.field })

        const name_index = mapper.indexOf('name')
        this.columnsLabel[name_index].editable = false

        const price_index = mapper.indexOf('price')
        this.columnsLabel[price_index].editable = false

        const action_index = mapper.indexOf('delete')
        this.columnsLabel.splice(action_index, 1)
      }
    },
    refreshCashBoxDetails () {
      getCashBoxOpeningInventories(this.selectedCashBox.id).then(response => {
        const cashBox = response.data.data
        const cashBox_index = this.data.map(elm => { return elm.id }).indexOf(cashBox.id)
        if (cashBox_index >= 0) {
          this.data[cashBox_index] = {
            rowNumber: this.data[cashBox_index].rowNumber,
            id: cashBox.id,
            name: cashBox.name,
            price: this.$u.priceFormat(cashBox.price),
            flag: 'SAVED'
          }

          if (this.$refs.cashBoxesOpeningBalanceList) this.$refs.cashBoxesOpeningBalanceList.setTableData()
        }
      })
        .catch(error => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          }
        })
    },
    deleteCashBoxDetails () {
      const cashBox_index = this.data.map(elm => { return elm.id }).indexOf(this.selectedCashBox.id)
      if (cashBox_index >= 0) this.data[cashBox_index].price = '0'

      getCashBoxesOpeningInventories(1).then(response => {
        // if (response.data.pagination.current_page === 1) {
        //   const row_index = this.columnsLabel.map((e) => {
        //     return e.field
        //   }).indexOf('rowNumber')
        //   this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
        // }
      })
        .catch(error => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          }
        })

      if (this.$refs.cashBoxesOpeningBalanceList) this.$refs.cashBoxesOpeningBalanceList.setTableData()
    },
    handleInsertNewCashBox (cash) {
      this.newSuggestCashBoxPromptStatus = false
      const insertedCash = {
        rowNumber: this.data.length + 1,
        id: cash.id,
        name: cash.name,
        price: '0',
        flag: 'new'
      }
      this.data.push(insertedCash)
      this.selectedCashBox = insertedCash
      this.editOpeningInventoryPromptStatus = true
      const row_index = this.columnsLabel.map((e) => {
        return e.field
      }).indexOf('rowNumber')
      this.columnsLabel[row_index].footer = {value: this.data.length}
    }
  },
  watch: {
    '$store.state.helper.openingBalanceChanged': {
      handler (val) {
        if (val) {
          if (this.insertOpeningInventoryPromptStatus) {
            this.page = 1
            this.data = []
            this.$nextTick(() => {
              this.getCashBoxesOpeningBalance()
            })
          }

          if (this.editOpeningInventoryPromptStatus && this.selectedCashBox) this.refreshCashBoxDetails()

          this.insertOpeningInventoryPromptStatus = false
          this.editOpeningInventoryPromptStatus = false
        }
      },
      deep: true
    },
    '$store.state.helper.openingBalanceDeleted': {
      handler (val) {
        if (val) {
          if (this.editOpeningInventoryPromptStatus && this.selectedCashBox) this.deleteCashBoxDetails()
          this.editOpeningInventoryPromptStatus = false
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.cash-boxes-opening-balance {
  height: 100%;
}
</style>
